import React, { useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { contactSchema } from '../../Validations/contact.validation';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import config from '../../config/config';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslation } from '../../i18n/LanguageContext';


export const ContactForm = () => {

    const [loading, setLoading] = useState(false)

    const { t } = useTranslation()

    const { executeRecaptcha } = useGoogleReCaptcha();

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(contactSchema)
    });

    const onSubmit = async (data) => {
        try {
            if (!executeRecaptcha) {
                console.log('Execute recaptcha not yet available');
                return;
            }

            setLoading(true);

            const token = await executeRecaptcha()

            if (!token) {
                console.log('Captcha inválido');
                setLoading(false);
                return;
            }

            const response = await fetch(`${config.backURL}/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ...data, token }),
            });

            const json = await response.json();
            notify(json.status, json.message);

            reset();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            notify('error', t('contact.form.sendError'));
        }
    };

    const notify = (value, message) => {
        if (value === 'success') return toast.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "light",
            style: {
                fontSize: '18px'
            }
        })
        return toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "light",
            style: {
                fontSize: '18px'
            }
        })
    };

    return (
        <div className="contactFormCont">
            <form id="contactForm" className="contactForm" onSubmit={handleSubmit(onSubmit)}>
                <div className="contactFormHeader">
                    <h3>{t('contact.form.title')}</h3>
                    <p>{t('contact.form.required')}</p>
                </div>

                <div className="contactFields">
                    <div className="contactField">
                        <label htmlFor="cf-name">{t('contact.form.name')}</label>
                        <input {...register('name')} id="cf-name" type="text" name="name" />
                        <p className='error'>{errors.name && t(errors.name.message)}</p>
                    </div>

                    <div className="contactField">
                        <label htmlFor="cf-email">{t('contact.form.email')}</label>
                        <input {...register('email')} id="cf-email" type="email" name="email" />
                        <p className='error'>{errors.email && t(errors.email.message)}</p>
                    </div>

                    <div className="contactField">
                        <label htmlFor="cf-number">{t('contact.form.phone')}</label>
                        <input {...register('number')} id="cf-number" type="tel" name="number" />
                        <p className='error'>{errors.number && t(errors.number.message)}</p>
                    </div>

                    <div className="contactField">
                        <label htmlFor="cf-enterprise">{t('contact.form.enterprise')}</label>
                        <input {...register('enterprise')} id="cf-enterprise" type="text" name="enterprise" />
                        <p className='error'>{errors.enterprise && t(errors.enterprise.message)}</p>
                    </div>
                </div>

                <div className="contactField">
                    <label htmlFor="cf-subject">{t('contact.form.subject')}</label>
                    <input {...register('subject')} id="cf-subject" type="text" name="subject" />
                    <p className='error'>{errors.subject && t(errors.subject.message)}</p>
                </div>

                <div className="contactField">
                    <label htmlFor="cf-message">{t('contact.form.message')}</label>
                    <textarea {...register('message')} id="cf-message" name="message" rows="5"></textarea>
                    <p className='error'>{errors.message && t(errors.message.message)}</p>
                </div>

                <div className="contactFormFooter">
                    <span>{t('contact.form.recaptcha')}</span>
                    <input type="submit" className="contactSubmit" disabled={loading}
                        value={loading ? t('contact.form.sending') : t('contact.form.send')}
                    />
                </div>
            </form>
            <ToastContainer />
        </div>
    )
}
